import React from "react";
import TurnrDropdownSelect from "~/components/input/TurnrDropdownSelect.jsx";
import { InputGridWrapper, SettingsContainerWrapper } from "./settingComponents";

export default function ButtonDesignSettings(props) {
    const { iFrameData } = props;
    return (
        <SettingsContainerWrapper>
            <InputGridWrapper>
                <TurnrDropdownSelect
                    size={"small"}
                    label="Input variant"
                    tooltip="Change the overall style of your input fields"
                    fullWidth={true}
                    {...props.inputVariant}
                    onChange={props.setInputVariant}
                    options={iFrameData?.inputVariantOptions || []}
                />
            </InputGridWrapper>
            <InputGridWrapper>
                <TurnrDropdownSelect
                    size={"small"}
                    label="Input edges"
                    tooltip="Change roundness inputs and textareas"
                    fullWidth={true}
                    {...props.inputType}
                    onChange={props.setInputType}
                    options={iFrameData?.inputTypeOptions || []}
                />
            </InputGridWrapper>
            <InputGridWrapper>
                <TurnrDropdownSelect
                    size={"small"}
                    label="Checkbox edges"
                    tooltip="Change roundness of checkboxes"
                    fullWidth={true}
                    {...props.checkboxType}
                    onChange={props.setCheckboxType}
                    options={iFrameData?.checkboxTypeOptions || []}
                />
            </InputGridWrapper>
        </SettingsContainerWrapper>
    );
}
